import type { ParagraphMeta } from '../../../interfaces';

type HappyContestType = {
  type: 'external_script_happycontest';
  field_src: string;
  field_id: string;
};

type LoadbeeType = {
  type: 'external_script_loadbee';
  field_shop_id: string;
  field_url_products: string;
  field_api_key: string;
};

type LiveshoppingType = {
  type: 'video_liveshopping';
  field_video_id: string;
};

type GeneralScriptType = {
  type: 'externalscript';
  field_script_type:
    | 'smartAssistant'
    | 'sovendus'
    | 'trustedShops'
    | 'zoovu'
    | 'zoovu_url'
    | '3d_rooms'
    | 'kueche_co'
    | 'flixmedia'
    | 'unknown';
  field_api_key?: string;
};

export type ExternalScriptType = ParagraphMeta &
  (HappyContestType | LoadbeeType | LiveshoppingType | GeneralScriptType);

export enum ExternalScriptTestIds {
  CustomScript = 'script__content',
  DefaultScript = 'script__default',
  HappyContestScript = 'script_HappyContest',
  HappyContestScriptNotAllowed = 'script_HappyContest_not_allowed',
  KuecheCoScript = 'script_kueche_co',
  KuecheCoScriptNotAllowed = 'script_kueche_co_not_allowed',
  LiveshoppingScript = 'script_LiveShopping',
  LiveshoppingScriptNotAllowed = 'script_LiveShopping_not_allowed',
  LoadbeeScript = 'script_loadbee',
  LoadbeeScriptNotAllowed = 'script_loadbee_not_allowed',
  Rooms3dScript = 'script_3drooms',
  Rooms3dScriptNotAllowed = 'script_3d_rooms_not_allowed',
  SmartAssistantScript = 'script_smartAssistant',
  SmartAssistantScriptNotAllowed = 'script_smartAssistant_not_allowed',
  SovendusScript = 'script__sovendus',
  TrustedShopsScript = 'script__trustedShops',
  ZoovuScript = 'script_zoovu',
  Flixmedia = 'script_flixmedia',
  FlixmediaNotAllowed = 'script_flixmedia_not_allowed',
}
